import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad1b8804"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "page_content_title" }
const _hoisted_6 = { class: "page_content_title_top" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "page_content_title_bottom" }
const _hoisted_10 = {
  key: 0,
  class: "green"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("合格 ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "warning"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("不良 ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "error"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("报废 ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { key: 3 }

import { onMounted, ref, reactive } from 'vue'
    import { materialDistributeExt } from '@/apis/ExWarehouse'
    import { model } from '@/interface'
    import { judgmentPlatform } from "@/utils/utils"

    // 搜索数据接口
    interface form extends model {
        total: number,
        name: string
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
        show: {
            type: Boolean,
            required: true
        },
        list: {
            type: Array,
            default: []
        }
    },
  emits: ['close', 'value'],
  setup(__props, { emit }) {

const props = __props

    const form = reactive<form>({
        capacity: 50,
        page: 0,
        total: 0,
        name: '',
    })

    // 搜索分类标签
    let tagList = ref<Array<{id: string, name: string, num: string}>>([])

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)
    let isOne = ref<boolean>(true)

    // 搜索框
    const searchInput = (data: any) => {
        form.page = 0
        finished.value = false
        list.value = []
        form.name = data
        onLoad()
    }

    // 搜索提交
    const submit = (): void => {
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 返回上一页带参数
    const jump = (item: any) => {
        emit('value', item)
    }

    // 获取物料列表数据
    const onLoad = async () => {
        loading.value = false;
        finished.value = true;
        // if (!finished.value) {
        //     loading.value = true;
        //     form.page = form.page + 1
        //     materialDistributeExt({
        //         capacity: form.capacity,
        //         page: form.page,
        //         model: {
        //             mmodelUnionName: form.name,
        //             status: 1
        //         }
        //     }).then(res => {
        //         if (refreshing.value) {
        //             list.value = []
        //             refreshing.value = false;
        //         }
        //         loading.value = false;
        //         if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
        //             form.total = res.data.total
        //             list.value.push(...res.data.records)
        //         } else {
        //             finished.value = true;
        //         }
        //     }).catch((err: any) => {
        //         loading.value = false;
        //         finished.value = true;
        //         if (refreshing.value) {
        //             list.value = []
        //             refreshing.value = false;
        //         }
        //     })
        // }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        form.page = 0
        loading.value = true;
        onLoad()
    }

    let status = ref<boolean>(false)

    

    

    // 关闭回调
    const close = () => {
        emit('close')
    }

    onMounted(() => {
        status.value = judgmentPlatform()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: props.show,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((props.show) = $event)),
    position: "bottom",
    style: { height: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close",
          onClick: close
        }, [
          _createVNode(_component_van_icon, {
            name: "arrow-down",
            size: "30",
            color: "#ffffff"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_pull_refresh, {
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
          onRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: loading.value,
              "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了~",
              onLoad: onLoad
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item1, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "page_content",
                      key: idx,
                      onClick: ($event: any) => (jump(item1))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          (item1.batch)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item1.materialName + ' | ' + item1.materialCode), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item1.materialName + ' | ' + item1.materialCode), 1)),
                          _createElementVNode("span", null, _toDisplayString(item1.outActnum) + _toDisplayString(item1.unitName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          (item1.qualityType === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_14))
                            : (item1.qualityType === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_19))
                              : (item1.qualityType === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_24))
                                : (_openBlock(), _createElementBlock("span", _hoisted_25, "- / ")),
                          _createElementVNode("span", null, _toDisplayString(item1.procedureName ? item1.procedureName : '-') + " / ", 1),
                          _createElementVNode("span", null, _toDisplayString(item1.batch ? item1.batch : '-'), 1)
                        ])
                      ])
                    ], 8, _hoisted_4))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["loading", "finished"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})